'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import type { DeviceCapabilityTier } from '@/lib/cross-platform-gating';
import { resolveCapabilityTier } from '@/lib/cross-platform-gating';
type NativeCapabilitySnapshot = {
  memoryMb: number | undefined;
  capabilityTier: DeviceCapabilityTier;
  hasNativeCapability: boolean;
};

/**
 * Reads `window.ViverseNativeDeviceCapability` after hydration and returns
 * a stable snapshot. Only `memoryMb` participates in Phase 1 tier resolution;
 * `availableMemoryMb`, `cpu`, and `gpu` are unused for now.
 *
 * Returns `hasNativeCapability: false` and tier `'unknown'` on desktop or
 * any mobile browser where the global is not injected.
 */
export function useNativeDeviceCapability() {
  const $ = _c(2);
  const [snapshot, setSnapshot] = useState(_temp);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const raw = window.ViverseNativeDeviceCapability;
      if (!raw) {
        return;
      }
      const memoryMb = typeof raw.memoryMb === "number" ? raw.memoryMb : undefined;
      setSnapshot({
        memoryMb,
        capabilityTier: resolveCapabilityTier(memoryMb),
        hasNativeCapability: true
      });
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  return snapshot;
}
function _temp() {
  return {
    memoryMb: undefined,
    capabilityTier: "unknown",
    hasNativeCapability: false
  };
}